import React, {useState} from "react";
import Modal from "react-responsive-modal";
import ModalAddUserConnection from "root/Modals/AddUserConnection/ModalAddUserConnection";

const useModalAddUserConnection = (onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false,  from_user_id: null,  user_id: null, user_id_raw: null, mode: 'none',team_id: null})  ;

    const onClickActivate = ( newMode, from_user_id, user_id, user_id_raw, team_id ) =>
    {
        switch ( newMode )
        {
            case 'create':
                setDialog ({ openState: true, from_user_id: from_user_id, user_id: user_id, user_id_raw: user_id_raw, mode: 'create', team_id: team_id});
                break ;
            case 'edit':
                setDialog ({ openState: true, from_user_id: from_user_id, user_id: user_id, user_id_raw: user_id_raw, mode: 'edit', team_id: team_id});
                break ;
        }
    }

    const onCloseModal = () =>
    {
        setDialog ({ openState: false, from_user_id: null, user_id: null, user_id_raw: null, key: null, mode: 'none', team_id: null});
    };

    const onSaveComplete = ( key ) =>
    {
        // Close the dialog
        setDialog ({ openState: false, from_user_id: null, user_id: null, user_id_raw: null, key: null, mode: 'none', team_id: null});

        // Tell the parent we're done
        onSaveCompleted( key ) ;
    };

    const render = ( props ) =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalAddUserConnection from_user_id={dialog.from_user_id} user_id={dialog.user_id}
                       user_id_raw={dialog.user_id_raw} onSaveCompleted={onSaveComplete} onClose={onCloseModal} mode={dialog.mode} team_id={dialog.team_id}/> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalAddUserConnection ;
